import { render, staticRenderFns } from "./AdminReferralDesk.vue?vue&type=template&id=6bbad38a"
import script from "./AdminReferralDesk.vue?vue&type=script&lang=js"
export * from "./AdminReferralDesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports